export function isExternalUrl(url: string | undefined): boolean {
  if (!url) {
    return false
  }
  return (
    !url.startsWith('Binary/') &&
    !url.startsWith('https://storage.medplum.com/binary')
  )
}
